<template>
  <v-card class="library-file__move-menu"> 
    <v-card-title>
      <v-btn small icon @click.stop="$emit('loadModalDirectory', breadcrumb.parentId)" v-if="!breadcrumb.root">
        <v-icon size="16">bhi-arrow-left</v-icon>
      </v-btn>
      <span :class="[breadcrumb.root ? 'ml':'']">{{breadcrumb.root ? 'Library' : breadcrumb.name}}</span>
      <v-btn small icon @click.stop="$emit('close')" class="library-file__move-menu_close">
        <v-icon size="12">bhi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-list link dense v-if="folders && folders.length > 0">
        <v-list-item link v-for="folder in folders" :key="folder.id" @click.stop="$emit('loadModalDirectory', folder.id)">
          <v-list-item-icon>
            <v-icon>bhi-folder-filled</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{folder.name}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-else>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <small>No subfolders, {{actionType=='move' ? 'move' : 'copy'}} here</small>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <!-- <v-btn icon small>
        <v-icon color="accent">bhi-folder-add-filled</v-icon>
      </v-btn> -->
      <span></span>
      <v-btn small text color="accent" @click.stop="clickHandler">
        {{actionType=='move' ? 'Move' : 'Copy'}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: 'LibraryFileActionMenu',
  props: {
    id: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    version: {
      type: Number,
      default: 0
    },
    actionType: {
      type: String,
      default: 'move'
    },
    modalDirectory: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      breadcrumbDefault: {
        id: null,
        version: 0,
        root: false
      }
    }
  },
  computed: {
    breadcrumb() {
      return {...this.breadcrumbDefault, ...this.formatBreadcrumbs()}
    },
    folders() {
      if (this.modalDirectory.entries && Array.isArray(this.modalDirectory.entries))
        return this.modalDirectory.entries.filter(x=>x.entryTypeId==12) 
      else return []
    }
  },
  methods: {
    formatBreadcrumbs() { // find last item in breadcrumbs 
      let b = this.modalDirectory.breadcrumb
      let breadcrumb = null
      let parentId = null
      if (b) rec(b, true)
      function rec(b, root=false) {
        let item = {}
        item.name = b.name
        item.id = b.id
        if (parentId) item.parentId = parentId
        if (root)
          item.root = root
        if (b.content && b.content.length > 0) {
          parentId = b.id
          rec(b.content[0])
        } else breadcrumb = item 
      }
      return breadcrumb
    },
    clickHandler() {
      this.$emit('close')
      this.$emit(this.actionType=='move' ? 'move' : 'copy', this.id, this.title, this.version, this.breadcrumb.id)
    }
  }
}
</script>

<style lang="scss">
.library-file {

  &__move-menu {
    .v-list {
      max-height: 150px;
      overflow: auto;
    }
    .v-card__title {
      background: $bh-blue;
      min-width: 335px;
      color: $bh-white;
      padding: 0 6px 0 6px;
      font-size: 1rem;
      line-height: 40px;
      display: flex;
      .ml {
        margin-left: 10px;
      }
      .v-icon {
        color: $bh-white;
      }
    }
    &_close {
      margin-left: auto;
    }
    .v-card__text {
      padding: 0px;
      .v-list {
        background: $bh-blue--4;
        .v-list-item {
          min-height: 30px;
          &__icon {
            align-self: center;
            &:first-child {
              margin: 0 3px 0 0;
              .v-icon {
                color: $bh-gray--2;
              }
            }
          }
          &__content {
            padding:0 !important;
            color: $bh-gray--2;
          }
        }
      }
    }
    .v-card__actions {
      background: $bh-blue--4;
      position: relative;
      justify-content: space-between;
      .v-btn {
        z-index: 1;
      }
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: $bh-white;
        opacity: 0.5;
        z-index: 0;
      }
    }
  }
}
</style>